<template>
  <div class="header">
    <img src="../assets/imgs/about_header.png" alt="" />
  </div>
  <div class="about">
    <div class="content">
      <div class="title">
        关于思勃
        <div class="sub_title">About Smart Path</div>
      </div>
      <div class="wrap">
        <img src="../assets/imgs/about_left.png" alt="" />
        <div class="des">
          思勃咨询成立于2008年，是一家电子商务咨询公司。我们研究并追踪中国网购市场的发展趋势，为客户提供各品类的深入细致的数据和咨询服务。<br /><br />
          基于对于中国网购市场多年的经验和理解，我们开发了一套特有的研究方法，对中国网购市场进行24小时不间断地监控、追踪、分析并总结相关趋势和消费动向。在海量的第一手资料的基础上，为客户制定专门的品类报告。我们不断地优化、升级我们的研究方法，从而和快速发展的中国网购市场保持同步。<br /><br />
          我们是一支对中国网购市场充满热情的高效团队，我们的成员拥有多行业的相关经验，例如咨询业、电子商务、服饰、快速消费品、金融服务、商务软件等。我们同时为跨国企业与本土企业提供各个类别的数据及咨询服务。
        </div>
      </div>
    </div>
  </div>
  <div class="connect">
    <div class="content">
      <div class="title">
        联系我们
        <div class="sub_title">Contact Us</div>
      </div>
      <div class="connect_data">
        电邮：info@smart-path.net<br />
        电话：+86-21-6427 6820<br />
        地址：上海市漕溪北路18号 上海实业大厦 18楼A-E座
      </div>
      <div class="map">
        <iframe
          src="map.html"
          width="1200"
          height="400"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  components: {},
  setup() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 1200px;
  margin: 0 auto;
  font-size: 0px;
  img {
    width: 1920px;
    margin-left: -360px;
  }
}
.content {
  width: 1200px;
  margin: 0 auto;
  .title {
    color: #2c2d3f;
    font-weight: bold;
    font-size: 32px;
    text-align: center;
    .sub_title {
      font-size: 16px;
      color: #8392a5;
      font-weight: normal;
      padding: 10px 0;
    }
  }
}
.about {
  .content {
    padding: 60px 0 40px 0;
    .wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 60px;
      .des {
        width: 556px;
        line-height: 30px;
        font-size: 16px;
        color: #596675;
      }
    }
  }
}
.connect {
  background: #fff;
  .content {
    padding: 60px 0;
    .connect_data {
      margin: 44px 0;
      line-height: 34px;
      text-align: center;
      font-size: 18px;
      color: #596675;
    }
    .map{
      overflow: hidden;
      border-radius: 16px;
    }
  }
}
</style>